import { useMemo } from 'react';

import { FilterProps, FilterSelectProps } from '@/types/filters';

const useFilterProps = <Multiple extends boolean>(
  props: FilterSelectProps<Multiple>,
): FilterProps<Multiple> => {
  return useMemo(() => {
    const commonProps: FilterProps<Multiple> = {
      size: 'small',
      maxWidth: 240,
    };

    if (!props) {
      return commonProps;
    }

    return { ...commonProps, ...props };
  }, [props]);
};

export default useFilterProps;
